import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import loadingGif from './../../../../images/loading.gif';
import { TradingEventsListState } from './TradingEventsList.state';

const Wrapper = styled('div', { label: 'Wrapper' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: 300ms opacity cubic-bezier(0.8, -0.02, 0.59, 0.96);
`;

const Loading = styled('div', { label: 'Loading' })`
    padding: 20px;
    width: 90px;
`;

const LoadingImg = styled('img', { label: 'LoadingImg' })`
    max-width: 100%;
`;

const Message = styled('div', { label: 'Message' })`
    color: #000;
    font-size: 14px;
`;

interface PropsType {
    tradingEventsListState: TradingEventsListState,
}
export const TradingEventsListLoading = observer('TradingEventsListLoading', (props: PropsType) => {

    const isLoading = props.tradingEventsListState.isLoading;

    if (isLoading === false) {
        return null;
    }

    return (
        <Wrapper>
            <Loading>
                <LoadingImg src={ loadingGif } alt='spinner'/>
            </Loading>
            <Message>
                Loading events...
            </Message>
        </Wrapper>
    );
});

